<template>
	<div class="p-col-12 p-grid">
		<div class="p-col-12 p-lg-6" :class="[commonService.isMobile() ? 'text-box-mobile' : 'text-box']">
			<p class="login-title">Transfer Market Platform</p>
			<p class="login-subtitle justified">Accelerate Your Negotiations with TiroLibre</p>
			<p v-if="!commonService.isMobile()" class="login-text justified">Our algorithm creates custom presentations for your players, enabling multiple negotiations in seconds. Connect with new club representatives and get direct assistance in our negotiation room for the best outcomes.</p>
			<p v-if="commonService.isMobile()" class="login-text justified">Create custom presentations for your players, allowing for quick and efficient negotiations. Connect with clubs, get direct assistance.</p>
			<div v-if="!commonService.isMobile()" class="p-lg-2 button-box" style="padding: 0px">
				<Button label="Try it" class="p-button-warning" style="color: white; font-weight: bold;" @click="toLogin" />
			</div>
		</div>
		<div class="p-col-12 p-lg-6" style="margin: auto">
			<div class="card card-w-title" style="width: 100%;">
				<Toast />
				<div class="p-grid">
					<img :src="commonService.getHomeAgent3ImageUrl()" alt="" style="width: 90%; margin: auto">
				</div>
			</div>
			<div v-if="commonService.isMobile()" class="p-col-4 button-box-mobile" style="margin-top: -30px; margin-bottom: 30px">
				<Button label="Try it" class="p-button-warning" style="color: white; font-weight: bold;" @click="toLogin" />
			</div>
		</div>
	</div>
</template>

<script>
import CommonService from "@/service/CommonService";

export default {
	commonService: null,
	created() {
		this.commonService = new CommonService();
	},
	methods: {
		toLogin() {
			this.$router.push("/login");
		},
	},
};
</script>

<style scoped>
.justified {
	text-align: justify;
	text-justify: inter-word;
}

.login-title {
	margin-top: -15px;
	font-size: 35px;
	font-weight: bold;
}

.login-subtitle {
	margin-top: -45px;
	font-size: 35px;
	font-weight: bold;
}

.login-text {
	margin-top: 10px;
	font-size: 19px;
}

.text-box {
	margin: auto;
	padding-left: 50px;
}

.text-box-mobile {
	margin: auto;
}

.button-box {
	margin-top: 20px;
}

.button-box-mobile {
	margin: auto;
}

@media (min-width: 0px) and (max-width: 1000px) {
	.login-title {
		margin-top: -15px;
		font-size: 45px;
		font-weight: bold;
	}

	.login-subtitle {
		margin-top: -40px;
		font-size: x-large;
	}

	.login-text {
		margin-top: 10px;
		font-size: 16px;
	}
}

@media (min-width: 1000px) and (max-width: 1500px) {
	.login-title {
		font-size: 22px;
	}

	.login-subtitle {
        margin-top: -20px;
        font-size: 22px;
	}
}
</style>